import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import MaterialView from "./material.view";
import MaterialGroupDetailView from "./materialGroupDetail.view";

const useMaterialRoutes = () => (
  <>
    <Route path={pages.material.path} element={<MaterialView />} />
    <Route
      path={`${pages.material.path}/:id`}
      element={<MaterialGroupDetailView />}
    />
  </>
);

export default useMaterialRoutes;
